import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'

// 创建 axios 实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 30000 // 上传文件需要更长超时时间
})

// 创建专用上传axios实例（支持大文件和更长超时）
const uploadRequest = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 120000 // 上传大文件预留2分钟超时
})

// 上传请求拦截器（同步token）
uploadRequest.interceptors.request.use(
  config => {
    const token = store.state.token || localStorage.getItem('token')
    if (token) {
      const hasBearer = /^Bearer\s+/i.test(token)
      const rawToken = hasBearer ? token.replace(/^Bearer\s+/i, '') : token
      config.headers.Authorization = `Bearer ${rawToken}`
      config.headers.token = rawToken
    }
    return config
  },
  error => Promise.reject(error)
)

// 上传响应拦截器
uploadRequest.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
)

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 优先从 Vuex 读取，其次回退到本地（兼容旧数据）
    const token = store.state.token || localStorage.getItem('token')
    if (token) {
      // 同时兼容 Authorization 与自定义 token 头
      const hasBearer = /^Bearer\s+/i.test(token)
      const rawToken = hasBearer ? token.replace(/^Bearer\s+/i, '') : token
      config.headers.Authorization = `Bearer ${rawToken}`
      config.headers.token = rawToken
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    // code 为 0 表示失败
    if (res.code === 0) {
      Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    // code 为 1 表示成功
    return res
  },
  error => {
    Message.error(error.message || '请求失败')
    return Promise.reject(error)
  }
)

export default request
export { uploadRequest }
